/*
 * Function to handle prefill functionality for select field,
 * since select field uses additional markup in order to render
 * select options.
 */
function setSelectFieldValue(selectField, fieldValueToSet) {
  const customSelectedPanel = selectField.nextElementSibling
  if (customSelectedPanel) {
    const customSelectOptions = customSelectedPanel.querySelectorAll('.c-custom-select-option')
    const customSelectOptionItem = Array.from(customSelectOptions).find(selectOptionElement => selectOptionElement.dataset.value === fieldValueToSet)

    if (customSelectOptionItem) {
      customSelectOptionItem.click()
    }
  }
}

/*
 * Function to handle prefill form functionality.
 */
export function formFieldPrefiller(formFieldElement, fieldValueToSet) {
  const formElementType = formFieldElement.type

  if (formElementType.includes('select')) {
    setSelectFieldValue(formFieldElement, fieldValueToSet)
    return
  }

  formFieldElement.value = fieldValueToSet
}
